import { render, staticRenderFns } from "./PricingTariffsList.vue?vue&type=template&id=0a976ad8"
import script from "./PricingTariffsList.vue?vue&type=script&lang=js"
export * from "./PricingTariffsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports